module.exports = __webpack_public_path__ + "assets/img/logo-b.e7b20f36.png";